import { color, Text } from '@starrez/starryui9';
import React from 'react';
import styled from 'styled-components';

interface IOptionSecondaryHeaderProps {
    caption: string;
}

export const OptionSecondaryHeader = ({ caption }: IOptionSecondaryHeaderProps) => {
    return (
        <StyledLI>
            <Text color={color.Grey.G70} variant="small.bold">
                {caption}
            </Text>
        </StyledLI>
    );
};

const StyledLI = styled.li`
    height: 40px;
    margin: 0;
    width: 100%;
    text-align: left;
    background: none;
    padding: 0 16px;
    display: flex;
    align-items: center;
    text-transform: uppercase;
`;
